/** Opzioni paese per filtri (Inventory, KPI, ecc.). */
export const FILTER_COUNTRY_OPTIONS = [
  'Italy',
  'Spain',
  'Germany',
  'France',
  'United Kingdom',
  'United States',
  'Netherlands',
  'Belgium',
  'Austria',
  'Switzerland',
  'Portugal',
  'Poland',
  'Sweden',
  'Denmark',
  'Ireland',
  'Czech Republic',
  'Romania',
  'Hungary',
  'Greece',
  'Other',
];
